// extracted by mini-css-extract-plugin
export default {"orderManagementWrapper":"Order_orderManagementWrapper__yvEZu","searchHeader":"Order_searchHeader__5CZRa"};